<template>
  <ActivityTemplate :is-status-claim="isGoogleIdExist">
    <template v-slot:icon>
      <div class="google mg-13">
        <b-icon
          icon="google"
          custom-size="mdi-23px"
          custom-class="connect-social-ic-google"
        />
      </div>
    </template>
    <template v-slot:title>
      <span class="head">{{ $t('profile.connect_with_google') }}</span>
    </template>
    <template v-slot:description>
      <p>{{ $t('profile.connect_google_acc') }}</p>
    </template>
    <template v-slot:button>
      <div v-if="!user.googleId">
        <g-signin-button
          :params="{ client_id: googleClientId }"
          @success="(res) => {$emit('onSignInGoogleSuccess', res)}"
          @error="(e) => {$emit('onSignInGoogleError', e)}"
        >
          <div class="google">
            <span class="text">
              {{ $t('profile.connect_with_google') }}
            </span>
          </div>
        </g-signin-button>
      </div>
      <div
        v-else
        class="google"
      >
        <span class="text-linked" >
          {{ user.googleEmail }}
        </span>
        <b-icon
          v-if="user.id && user.accountType !== 'GOOGLE'"
          icon="link-off"
          custom-size="mdi-18px"
          custom-class="connect-social-ic-unlink"
          @click.native="$emit('onDisconnect')"
        />
      </div>
    </template>
  </ActivityTemplate>
</template>

<script>
import ActivityTemplate from '@/features/ActivityTemplate'

export default {
  name: 'ConnectWithGoogle',
  components: {
    ActivityTemplate
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    googleClientId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isGoogleIdExist () {
      return Boolean(this.user.googleId)
    }
  }
}
</script>

<style lang="scss">
.connect-social-ic-google {
  color: #fff;
  padding: 1px 5px;
  background-color: #DB4437;
  border-radius: 50%;
}
.connect-social-ic-unlink {
  color: #7d7d7d;
  cursor: pointer;
}
.connect-social-ic-unlink:hover {
  cursor: pointer;
  color: #000;
}
</style>

<style lang="scss" scoped>
.google {
  span {
    float: left;
  }
  .text {
    margin: 0 5px 0 15px;
    vertical-align: top;
    font-size: 13px;
    color: #2193ff;
    font-weight: bold;
    text-decoration: underline;
  }
  .text:hover {
    color: #0079fd;
    cursor: pointer;
  }
  .text-linked {
    margin: 0 5px 0 15px;
    vertical-align: top;
    font-style: italic;
    font-size: 13px;
    text-decoration: underline;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
  }
}
.reward {
  float: left;
  span {
    vertical-align: middle;
  }
  &.claim {
    color: #7ed321;
  }
  &.wating {
    color: #afafaf;
  }
}
.mg-13 {
  margin: 0 0 13px 9px;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .reward {
    float: none;
    width: 100%;
    margin-top: 12px;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConnectWithGoogle.vue